import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logoutUser } from "../../slices/thunks";

const Logout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    // Call redux logout
    dispatch(logoutUser());

    // Clear local/session storage
    localStorage.clear();
    sessionStorage.clear();

    // Navigate to login
    navigate("/login");

    // 🔥 Force refresh (mandatory)
    window.location.reload();
  }, [dispatch, navigate]);

  return null;
};

export default Logout;
